import { useState } from "react";

function useDecimalFormat(initialValue: number): any {
  const [formattedValue, setFormattedValue] = useState<string>(
    formatNumber(initialValue)
  );

  function formatNumber(value: number): string {
    return value <= 9 ? `0${value}` : `${value}`;
  }

  function handleChange(value: string) {
    setFormattedValue(formatNumber(parseFloat(value)));
  }

  return [formattedValue, handleChange];
}

export default useDecimalFormat;
